import React, { Component } from 'react';
import { Card, CardTitle, CardText, CardHeader, CardActions } from 'material-ui/Card';
import { Link } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import AppStore from '../../stores/app-store.js'

import { deepOrange500 } from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const muiTheme = getMuiTheme({
    palette: {
        accent1Color: deepOrange500,
    },
});

const stylelink = {
    margin: 12,
    float: 'right',
};

class GuardaEAutoriza extends Component {
    constructor(props) {
        super(props);
        this.checaLido = this.checaLido.bind(this);
        this.state = {
            legendas: AppStore.legendas,
        }
        this.onChangeLingua = this.onChangeLingua.bind(this);
    }

    componentWillMount() {
        AppStore.addChangeLinguaListener(this.onChangeLingua);
    }

    componentWillUnmount() {
        AppStore.removeChangeLinguaListener(this.onChangeLingua);
    }


    onChangeLingua() {
        this.setState({
            legendas: AppStore.legendas,
        })
    }

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    }

    checaLido() {
        this.context.router.push('/guardahistoriaeautor');
    }

    render() {
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div className="GuardaEAutoriza">
                    <Card>
                        <CardHeader />
                        <CardTitle title={this.state.legendas.autorizacao} actAsExpander={true} showExpandableButton={true} />
                        <CardText expandable={true}>
                            Data de Entrada em Vigor: 31 Julho de 2017.

Os termos deste contrato (&quot;Termos de Uso&quot;) regem o relacionamento entre você e a

Associação Viva, em relação ao seu uso do jogo, websites e serviços relacionados da

Associação Viva (o &quot;Serviço&quot;).

Antes de acessar ou utilizar o Serviço, inclusive websites da Associação Viva, ou

acessar um jogo, você deve concordar com os Termos de Uso e a Política de

Privacidade. Pode ser necessário também que você registre uma conta no Serviço (uma

&quot;Conta&quot;). Ao registar uma Conta ou, de outro modo, usar o Serviço, você declara que o

usuário tem 13 anos de idade ou mais e que entende os Termos de Uso e concorda com

eles. Se tiver mais de 13 anos e menos de 18 anos, você declara, por meio de seu

responsável, que seu responsável analisou e está de acordo com estes Termos. Caso

você acesse o Serviço a partir de um Site de Rede Social (&quot;SRS&quot;), como o Facebook ou

o Google+, você deve obedecer aos termos de serviço/uso desses sites, bem como aos

Termos de Uso.

AO INSTALAR, UTILIZAR OU ACESSAR O SERVIÇO, VOCÊ ESTARÁ DE

ACORDO COM ESTES TERMOS DE USO. SE NÃO ESTIVER DE ACORDO COM

ESTES TERMOS DE USO, NÃO INSTALE, USE OU ACESSE O SERVIÇO. O USO

DE SERVIÇO SERÁ CONSIDERADO NULO ONDE FOR PROIBIDO.

A Associação Viva e Deixe Viver se reserva o direito de, a seu critério, alterar,

modificar, adicionar ou remover partes destes Termos de Uso e da sua Política de

Privacidade a qualquer momento.

1. Licença

1.1. Concessão de Licença Limitada para Uso do Serviço

Condicionado à sua concordância com estes Termos de Uso e outras políticas aplicáveis

da Associação Viva e seu cumprimento continuado dos mesmos, a Associação Viva

concede a você uma licença não exclusiva, intransferível, não sub-licenciável, revogável

e sujeita às limitações abaixo para o acesso e uso do Serviço para seus próprios fins de

entretenimento não comerciais. Você concorda em não usar o Serviço para nenhuma

outra finalidade.

Aplicam-se as seguintes restrições ao uso do Serviço:

 Você não está autorizado a criar uma Conta ou acessar o Serviço caso tenha

menos de 13 anos de idade; você deve restringir o uso por menores de idade e

negar o acesso a crianças menores que 13 anos. Você aceita plena

responsabilidade pelo uso não autorizado do Serviço por menores. Você é

responsável pelo uso de seu cartão de crédito ou outro instrumento de

pagamento (por exemplo, paypal) por menores.

 Você não poderá vender, alugar ou dar sua Conta, criar uma Conta usando

identidade ou dados falsos, ou em nome de outrem; você não poderá usar o

Serviço caso já tenha sido removido de ou proibido anteriormente de jogar

qualquer jogo da Associação Viva;.

 Você deve usar sua Conta apenas para fins não comerciais; você não poderá usar

o Serviço para fazer propaganda ou solicitar ou transmitir propagandas

comerciais, inclusive correntes, mala direta, spam ou mensagens consecutivas a

ninguém;

Dados de Acesso e sua Conta

Durante o processo de criação da Conta, você deverá escolher uma senha (&quot;Dados de

Acesso&quot;). Você não poderá compartilhar a Conta ou os Dados de Acesso ou permitir

que alguém acesse sua Conta ou fazer qualquer outra coisa que possa comprometer a

segurança da sua Conta. Caso tenha conhecimento ou suspeite de violações de

segurança, inclusive, sem limitação, perda, roubo ou divulgação não autorizada dos

Dados de Acesso, você deve notificar imediatamente a Associação Viva e modificar

seus Dados de Acesso. Você é o único responsável pela manutenção da

confidencialidade dos Dados de Acesso e será responsável por todos os usos dos Dados

de Acesso autorizados ou não por você, inclusive compras. Você é responsável por tudo

o que acontecer através da sua Conta.

A Associação Viva se reserva o direito de remover ou recuperar quaisquer nomes de

usuário, a qualquer momento e por qualquer motivo, inclusive, sem limitação, alegações

de terceiros de que um nome de usuário viole os direitos de terceiros.

O Serviço suporta apenas uma Conta por jogo em um dispositivo compatível.

Limitações de Licença

Qualquer uso do Serviço em descumprimento  a estas Limitações de Licença é

estritamente proibido e poderá resultar na revogação imediata de sua licença limitada e

responsabilizá-lo por violações da lei.

Você concorda em se abster, sob quaisquer circunstâncias, de:

 Tomar parte em qualquer ato que a Associação Viva considere estar em conflito

com o espírito ou o propósito do Serviço ou fazer uso indevido dos serviços.

 Usar trapaças, explorar erros, usar softwares de automação, bots, hacks,

modificações ou qualquer software de terceiros não autorizado projetado para

modificar o Serviço ou interferir no Serviço, em Jogos da Associação Viva ou

na experiência de jogo da Associação Viva ou, sem o consentimento expresso

por escrito da Associação Viva, modificar ou fazer com que se modifiquem os

arquivos que fazem parte do Serviço ou de jogos da Associação Viva.

 Interromper, sobrecarregar ou auxiliar ou dar assistência na interrupção ou na

sobrecarga de qualquer computador ou servidor (&quot;Servidor&quot;) utilizado para

oferecer ou dar apoio ao Serviço ou a ambientes de jogo da Associação Viva.

 Instituir, ajudar, ou se envolver em qualquer tipo de ataque, inclusive, sem

limitação, distribuição de vírus, ataques de negação de serviço ou outras

tentativas de interromper o Serviço ou o uso ou fruição do Serviço por parte de

outra pessoa.

 Tentar obter acesso não autorizado ao Serviço, a Contas registradas para outros

ou aos computadores, Servidores ou redes conectadas ao Serviço por quaisquer

meios diversos da interface de usuário fornecida pela Associação Viva,

incluindo, mas não se limitando a, contorno ou modificação, tentativa de

contorno ou modificação, ou incentivo ou auxílio a terceiros ao contorno ou a

modificação de segurança, tecnologia, dispositivo ou softwares que façam parte

do Serviço.

 Publicar qualquer informação que seja abusiva, ameaçadora, obscena,

difamatória, caluniosa, ou ainda de teor questionável ou ofensivo, seja de forma

racial, sexual, religiosa ou de outro modo.

 Publicar informações que contenham nudez, violência excessiva, material

ofensivo ou que tenham links para tais conteúdos.

 Disponibilizar através do Serviço materiais ou informações que infrinjam

direitos autorais, marcas, patentes, segredos comerciais, direitos de privacidade,

direito de publicidade ou outros direitos de terceiros ou de pessoas jurídicas ou

que personifiquem outra pessoa, inclusive e sem limitação.

 Fazer engenharia reversa, descompilar, desmontar, decifrar ou tentar obter o

código fonte de softwares subjacentes ou outras propriedades intelectuais usadas

para prestar o Serviço ou jogo da Associação Viva.

 Solicitar ou tentar solicitar informações pessoais de outros usuários do Serviço

ou do jogo Associação Viva ou coletar ou publicar informações privadas de

alguém, inclusive dados de identificação pessoal (seja em forma de texto,

imagem ou vídeo), documentos de identificação ou informações financeiras

através do Serviço.

A Associação Viva se reserva o direito de determinar quais condutas considera violar as

regras de uso ou que, de outra forma, estejam fora da intenção ou do espírito destes

Termos de Uso ou do próprio Serviço. A Associação Viva se reserva o direito de tomar

medidas, como resultado de tais condutas, o que pode incluir o encerramento de sua

Conta e a proibição do seu uso do Serviço, no todo ou em parte.



1.2. Suspensão e Cessação da Conta e do Serviço



SEM LIMITAÇÃO A OUTRAS TUTELAS, A ASSOCIAÇÃO VIVA E DEIXE

VIVER PODERÁ LIMITAR, SUSPENDER, ENCERRAR, MODIFICAR OU

EXCLUIR CONTAS OU O ACESSO AOS SERVIÇOS OU A PARTES DOS

SERVIÇOS DA ASSOCIAÇÃO VIVA EM CASO DE DESCUMPRIMENTO ESTES

TERMOS DE USO OU CASO A ASSOCIAÇÃO VIVA E DEIXE VIVER SUSPEITE

QUE VOCÊ DEIXOU DE CUMPRI-LOS, OU AINDA POR USO ILEGAL OU

INADEQUADO DO SERVIÇO, OU PELA SUSPEITA DE TAL USO, SEM

AVISO,VOCÊ PODERÁ PERDER SEU NOME E SEU PERSONAGEM COMO

RESULTADO DO ENCERRAMENTO OU DA LIMITAÇÃO DA CONTA, BEM

COMO BENEFÍCIOS, PRIVILÉGIOS, ITENS ADQUIRIDOS E ITENS

COMPRADOS RELACIONADOS AO SEU USO DO SERVIÇO, FICANDO A

ASSOCIAÇÃO VIVA E DEIXE VIVER DESOBRIGADA DE INDENIZÁ-LO POR

TAIS PERDAS OU RESULTADOS.

SEM LIMITAÇÃO DE NOSSAS DEMAIS TUTELAS, PODEMOS LIMITAR,

SUSPENDER OU ENCERRAR O SERVIÇO E CONTAS DE USUÁRIO OU

PARTES DOS MESMOS, PROIBIR O ACESSO A NOSSOS JOGOS E SITES, BEM

COMO AO CONTEÚDO, AOS SERVIÇOS E ÀS FERRAMENTAS DESSES,

ATRASAR OU REMOVER CONTEÚDOS HOSPEDADOS E ADOTAR MEDIDAS

TÉCNICAS E JURÍDICAS PARA IMPEDIR QUE USUÁRIOS ACESSEM O

SERVIÇO, CASO ACREDITEMOS QUE ELES CRIAM RISCO OU POSSÍVEIS

RESPONSABILIDADES LEGAIS, VIOLAM DIREITOS DE PROPRIEDADE

INTELECTUAL DE TERCEIROS, OU AJAM DE FORMA INCONSISTENTE COM

O TEOR OU O ESCOPO DE NOSSOS TERMOS OU POLÍTICAS. ALÉM DISSO,

PODEREMOS, EM CIRCUNSTÂNCIAS ADEQUADAS E A NOSSO CRITÉRIO

EXCLUSIVO, SUSPENDER OU ENCERRAR CONTAS DE USUÁRIOS QUE

POSSAM SER INFRATORES REINCIDENTES DE DIREITOS DE PROPRIEDADE

INTELECTUAL DE TERCEIROS.

A ASSOCIAÇÃO VIVA E DEIXE VIVER SE RESERVA O DIREITO DE

ENCERRAR CONTAS QUE ESTEJAM INATIVAS POR 180 DIAS.

A Associação Viva se reserva o direito de parar de oferecer e/ou de manter o Serviço ou

jogo específico ou parte do Serviço a qualquer momento, momento no qual sua licença

para usar o Serviço ou parte do mesmo será automaticamente cancelada. Nesse caso, a

Associação Viva não terá obrigação de fornecer restituições, benefícios ou outras

indenizações para os usuários em relação a tais Serviços interrompidos. O encerramento

de sua Conta poderá incluir a desativação do acesso ao Serviço ou a partes dele,

inclusive conteúdos enviados por você ou por terceiros.

2. Propriedade

2.1. Jogos e Serviço

Todos os direitos, títulos e direitos reais sobre o Serviço (inclusive, sem limitação,

jogos, títulos, códigos de computador, temas, objetos, personagens, nomes de

personagens, histórias, diálogos, bordões, conceitos, trabalhos de arte, animações, sons,

composições musicais, efeitos audiovisuais, métodos de operação, direitos morais,

documentação, transcrições de bate-papo dentro do jogo, informações de perfil de

personagens, gravações de jogos jogados através do uso de um cliente de jogo da

Associação Viva e Deixe Viver) ficam reservados à Viva, incluindo, mas não se

limitando, direitos de propriedade intelectual ou outros direitos de propriedade,

relacionados aos jogos e ao Serviço.

2.2. Contas

NÃO OBSTANTE DISPOSIÇÕES EM CONTRÁRIO AQUI EXPRESSAS, VOCÊ

RECONHECE E CONCORDA QUE NÃO TERÁ PROPRIEDADE OU OUTROS

DIREITOS REAIS DE PROPRIEDADE SOBRE A CONTA, E VOCÊ RECONHECE

E CONCORDA AINDA QUE TODOS OS DIREITOS SOBRE A CONTA SÃO E

SERÃO SEMPRE DE PROPRIEDADE E PARA O BENEFÍCIO DA ASSOCIAÇÃO

VIVA E DEIXE VIVER.

2.3. Itens virtuais

A Associação Viva possui, licenciou, ou tem os direitos para usar todo o conteúdo que

aparece no Serviço ou em jogos da Associação Viva. Não obstante qualquer disposição

em contrário aqui, você concorda que você não tem direito ou título ou a qualquer

conteúdo que aparece no Serviço, inclusive, sem limitação, os bens virtuais ou moeda

aparecendo ou originários de qualquer jogo da Associação Viva, se ganhou em um jogo

ou se foi comprado da Associação Viva, ou quaisquer outros atributos associados a uma

Conta ou armazenados no Serviço.

2.4. Conteúdo de Usuário

“Conteúdo de Usuário” significa quaisquer comunicações, imagens, sons, e os

materiais, dados e informações que você envie ou transmita através de um cliente de

jogo da Associação Viva ou do Serviço, ou que outros usuários enviem ou transmitam,

inclusive, sem limitação, textos de chat. Ao transmitir ou enviar Conteúdos de Usuário

durante o uso do Serviço, você afirma, declara e garante que tal transmissão ou

apresentação (A) é correta e não confidencial; (B) não viola leis, restrições contratuais

ou outros direitos de terceiros, e que você tem permissão de terceiros cujas informações

pessoais ou propriedades intelectuais façam parte do Conteúdo de Usuário; (C) é livre

de vírus, adware, spyware, worms ou outros códigos maliciosos; e (D) você reconhece e

concorda que suas informações pessoais que façam parte de tal conteúdo sempre serão

processadas pela Associação Viva em conformidade com sua Política de Privacidade. A

Associação Viva se reserva o direito, a seu exclusivo critério de revisar, monitorar,

proibir, editar, apagar, desabilitar o acesso ou indisponibilizar Conteúdos de Usuário

(inclusive, sem limitação, o seu Conteúdo de Usuário), sem aviso prévio, por qualquer

motivo ou sem motivo, a qualquer momento.

3. Conteúdos de Usuário

3.1. Monitoração de conteúdo

A Associação Viva não assume responsabilidade pela conduta de usuários que enviem

Conteúdo de Usuário, e não assume nenhuma responsabilidade de monitorar o Serviço

para localizar conteúdo ou conduta inadequada. Não monitoramos, nem podemos

monitorar todo o Conteúdo de Usuário. Seu uso do Serviço é realizado por sua Conta e

risco. Ao usar o Serviço, você poderá ser exposto a Conteúdo de Usuário que é

ofensivo, indecente ou que de outro modo não esteja de acordo com suas expectativas.

Você assume todos os riscos associados ao uso de Conteúdos de Usuário disponíveis

relativos ao Serviço. A nosso critério, nossos representantes ou nossa tecnologia podem

monitorar e/ou registrar a sua interação com o Serviço ou suas comunicações (inclusive,

sem limitação, textos de bate-papos), quando você usar o Serviço.

Pelo presente, ao aderir a estes Termos de Uso, você consente irrevogavelmente com tal

monitoração e registro. Você reconhece e concorda que não tem expectativas de

privacidade acerca da transmissão de Conteúdos de Usuário, inclusive, sem limitação,

textos de bate-papos ou comunicações de voz.

Se, a qualquer tempo, a Associação Viva escolher, a seu critério exclusivo, monitorar o

Serviço, a Associação Viva não assume responsabilidade pelo Conteúdo de Usuário e

não assume obrigação de modificar ou remover Conteúdos de Usuário inadequados.

Temos o direito, mas não a obrigação, a nosso critério exclusivo, de editar, recusar a

postagem, ou remover Conteúdos de Usuário.

3.2. Uso de Informações por Outros Membros do Serviço

3.2.1. Discurso Público

O Serviço pode incluir vários fóruns, blogs e recursos de bate-papo nos quais você pode

postar Conteúdos de Usuário, inclusive suas observações e comentários sobre temas

designados. A Associação Viva não pode garantir que outros membros não usarão as

ideias e informações que você compartilha. Portanto, caso você tenha ideias ou

informações que gostaria de manter confidenciais e/ou não deseja que outros usem, não

as poste no Serviço. A Associação Viva não se responsabiliza por avaliar, usar ou

compensá-lo por ideias ou informações que você pode optar por enviar.

3.2.2. Responsabilidade pelo Conteúdo Próprio

Você é o único responsável pelas informações que você posta no Serviço, através do

Serviço ou relacionadas ao mesmo e que você fornece para outros. A Associação Viva

pode rejeitar, recusar a postagem ou excluir Conteúdos de Usuário por qualquer motivo

ou sem motivo, inclusive, sem limitação, Conteúdos de Usuário que, a critério exclusivo

da Associação Viva, violem os Termos de Uso.

3.3. Licença

Pelo presente, você concede à Associação Viva uma licença irrevogável, perpétua,

transferível, totalmente integralizada, isenta de royalties, e mundial (inclusive o direito

de sublicenciar e ceder a terceiros) e o direito de copiar, reproduzir, corrigir, adaptar,

modificar, criar trabalhos derivados, fabricar, comercializar, publicar, distribuir, vender,

licenciar, sublicenciar, transferir, alugar, transmitir, exibir publicamente, executar

publicamente, ou fornecer acesso eletronicamente, transmitir por radiodifusão,

comunicar ao público por telecomunicações, exibir, executar, armazenar em memória

de computador, e usar e praticar, de qualquer forma, seus Conteúdos de Usuário, bem

como todas as obras modificadas e derivadas dos mesmos em relação à nossa prestação

do Serviço, inclusive a comercialização e promoções do Serviço. Além disso, você

concede à Associação Viva o direito incondicional e irrevogável de uso e exploração do

seu nome, da sua imagem e de outras informações ou materiais incluídos em Conteúdos

de Usuário relacionados a Conteúdos de Usuário, sem qualquer obrigação para com

você. Exceto no que for proibido por lei, você renuncia a direitos de atribuição e/ou

direitos morais que você possa ter sobre seus Conteúdos de Usuário, independentemente

de tais Conteúdos de Usuário terem sido alterados ou modificados de qualquer maneira.

A Associação Viva não reivindica direitos de propriedade sobre o seu Conteúdo de

Usuário e nada nestes Termos de Uso visa restringir os direitos que você possa ter de

uso e exploração do seu Conteúdo de Usuário. A Associação Viva não tem obrigação de

monitorar ou fazer valer os seus direitos de propriedade intelectual sobre o seu

Conteúdo de Usuário.

3.4. Interações do usuário

Você é o único responsável por suas interações com outros usuários do Serviço e com

outras partes com as quais você interaja através do Serviço e/ou dos jogos da

Associação Viva. Você cooperará de forma plena com a Associação Viva para

investigar atividades suspeitas, ilegais, fraudulentas ou inadequadas, inclusive, sem

limitação, a concessão de acesso à Associação Viva a partes da sua Conta protegidas

por senha.

Em caso de litígio com um ou mais usuários, você nos exonera (e aos nossos diretores,

agentes, subsidiárias, joint ventures e funcionários) de ações, demandas e indenizações

(por dano direto e indireto) de qualquer tipo e natureza, conhecidos e desconhecidos,

decorrentes ou de qualquer modo relacionados a tais disputas.

4. Taxas e Termos de Compra

4.1. Compras

No Serviço você pode comprar, com dinheiro &quot;do mundo real&quot;, uma licença limitada,

pessoal, intransferível, não sublicenciável e revogável para usar (a) &quot;moeda virtual&quot;,

incluindo, mas não se limitando a dinheiro virtual ou diamantes, tudo para utilização em

jogo da Associação Viva; (b) &quot;itens do jogo virtuais&quot; (juntamente com a &quot;moeda

virtual&quot;, &quot;Itens Virtuais&quot;); e (c) outros produtos ou serviços (&quot;Mercadorias&quot;).

A transferência de Itens Virtuais e Mercadoria é proibida, exceto quando autorizada

expressamente no Serviço. A menos que expressamente autorizado no Serviço, você

não poderá vender, trocar ou, de outro modo, transferir Itens Virtuais ou Mercadorias a

outras pessoas físicas ou jurídicas, inclusive, sem limitação, à Associação Viva, a outros

usuários ou a terceiros.

TODAS AS COMPRAS E RESGATE DE MOEDAS VIRTUAIS DE TERCEIROS

FEITAS ATRAVÉS DO SERVIÇO SÃO FINAIS E NÃO REEMBOLSÁVEIS.

4.2. Pagamento de Taxas

Você concorda em pagar todas as taxas e impostos incorridos por você ou por outros

através de uma Conta registrada para você. A Associação Viva poderá rever os preços

para os produtos e serviços oferecidos através do Serviço a qualquer momento. VOCÊ

RECONHECE QUE A ASSOCIAÇÃO VIVA NÃO TEM OBRIGAÇÃO DE

REEMBOLSO POR QUALQUER MOTIVO E QUE VOCÊ NÃO RECEBERÁ

DINHEIRO OU OUTRAS COMPENSAÇÕES POR ITENS VIRTUAIS NÃO

UTILIZADOS QUANDO UMA CONTA FOR ENCERRADA, SEJA TAL

ENCERRAMENTO VOLUNTÁRIO OU NÃO.

5. Atualizações do Serviço

Você entende que o Serviço se encontra em evolução. A Associação Viva pode requerer

que você aceite atualizações do Serviço e dos jogos que você tenha instalado em seu

computador. Você reconhece e concorda que a Associação Viva pode atualizar o

Serviço e os jogos, notificando-o ou não. Pode ser necessário que você atualize

softwares ao longo do tempo, a fim de receber o Serviço e jogar Jogos da Associação

Viva.

6. Renúncia de Garantias

SEM LIMITAÇÃO DA RESPONSABILIDADE DA ASSOCIAÇÃO VIVA

PREVISTA NA SEÇÃO 7 ABAIXO, O SERVIÇO É FORNECIDO &quot;COMO SE

ENCONTRA&quot; E &quot;CONFORME DISPONÍVEL&quot; PARA SEU USO, SEM GARANTIAS

DE QUALQUER TIPO, EXPRESSAS OU IMPLÍCITAS, INCLUSIVE, SEM

LIMITAÇÃO, AS GARANTIAS DE COMERCIALIZAÇÃO, ADEQUAÇÃO A UM

DETERMINADO FIM, TÍTULO, NÃO VIOLAÇÃO, E AQUELAS DECORRENTES

DO DECURSO DO TRATAMENTO DE COMÉRCIO OU DO USO DO MESMO DE

NEGOCIAÇÃO OU USO COMERCIAL. A ASSOCIAÇÃO VIVA NÃO GARANTE

QUE VOCÊ TENHA CONDIÇÕES DE ACESSAR OU USAR O SERVIÇO NOS

MOMENTOS OU LOCAIS DE SUA ESCOLHA; QUE O SERVIÇO SEJA

INTERROMPIDO OU ISENTO DE ERROS; QUE DEFEITOS SERÃO

CORRIGIDOS; OU QUE O JOGO OU O SERVIÇO SEJAM LIVRES DE VÍRUS OU

DE OUTROS COMPONENTES NOCIVOS.

7. Limitação de Responsabilidade; Tutela Única e Exclusiva; Indenização

A ASSOCIAÇÃO VIVA NÃO SERÁ RESPONSÁVEL PARA COM VOCÊ POR

DANOS INDIRETOS, INCIDENTAIS, CONSEQUENTES, ESPECIAIS, PUNITIVOS

OU DE SIMILARES INCLUINDO, MAS NÃO SE LIMITANDO, PERDA DE

RECEITA, LUCROS CESSANTES, PERDA DE DADOS OU INTERRUPÇÃO DE

NEGÓCIOS OU OUTRAS PERDAS INTANGÍVEIS (PORÉM TAIS PERDAS SÃO

QUALIFICADAS), DECORRENTES DESTES TERMOS DE USO OU DO SERVIÇO

EM SI, OU RELACIONADOS DE QUALQUER FORMA AOS MESMOS, SEJA

COM BASE EM CONTRATO, ILÍCITO, OU OUTRAS TEORIAS LEGAIS, E

INDEPENDENTEMENTE DE A ASSOCIAÇÃO VIVA TER SIDO AVISADA DA

POSSIBILIDADE DE TAIS DANOS. A ASSOCIAÇÃO VIVA NÃO SERÁ

RESPONSÁVEL POR MAIS DO QUE O VALOR PAGO À ASSOCIAÇÃO VIVA

DE ACORDO COM ESTES TERMOS DE SERVIÇO NOS SEIS (6) MESES

IMEDIATAMENTE ANTERIORES À DATA NA QUAL VOCÊ INVOCOU

INICIALMENTE O SEU DIREITO. VOCÊ RECONHECE E CONCORDA QUE

CASO VOCÊ NÃO TENHA PAGO NADA À ASSOCIAÇÃO VIVA DURANTE TAL

INTERVALO DE TEMPO, SUA ÚNICA SOLUÇÃO (E RESPONSABILIDADE

EXCLUSIVA DA ASSOCIAÇÃO VIVA) PARA QUALQUER LITÍGIO COM A

ASSOCIAÇÃO VIVA É PARAR DE UTILIZAR O SERVIÇO E CANCELAR SUA

CONTA.

Algumas jurisdições não permitem a exclusão de determinadas garantias ou a limitação

ou a exclusão de responsabilidade por certos tipos de danos. Assim, algumas das

renúncias e limitações acima podem não se aplicar a você. Na medida em que a

Associação Viva não possa, por força da lei aplicável, deixar de reivindicar garantias ou

limitar sua responsabilidade da forma aqui estabelecida, o escopo dessa garantia e da

extensão da responsabilidade da Associação Viva serão o mínimo permitido pela

legislação aplicável.

Você concorda em indenizar, defender e proteger a Associação Viva e Deixe Viver de

reclamações, demandas, danos ou outras perdas, inclusive honorários advocatícios

razoáveis, reivindicados por terceiros resultantes ou decorrentes do seu uso do Serviço,

ou de violações de sua parte destes Termos de Uso. No entanto, o disposto acima não

será aplicado se a violação dos direitos não for atribuída a conduta dolosa ou culposa.

8. Resolução de Litígios e Lei

Em caso de litígio entre você e a Associação Viva, recomendamos que primeiro entre

em contato conosco diretamente para buscar uma solução. Se você reside no Brasil,

estes Termos de Uso e quaisquer litígios decorrentes dos mesmos ou da Política de

Privacidade ou Serviço, ou relacionados a eles, serão regidos em todos os seus aspectos

pelas leis nacionais, desconsiderando-se disposições de conflitos de lei. Você concorda

que qualquer reivindicação ou disputa que possa ter contra a Associação Viva deve ser

dirimida exclusivamente por um órgão jurisdicional localizado em São Paulo/SP. Se

você reside fora do Brasil, você concorda que todas as disputas entre você e a

Associação Viva serão regidas pelas leis do Brasil, desconsiderando-se disposições de

conflitos de lei. Você concorda que qualquer reivindicação ou disputa que você possa

ter contra a Associação Viva deve ser dirimida exclusivamente por um órgão

jurisdicional localizado em São Paulo/SP.

9. Independência das Cláusulas Contratuais

Fica acordado entre você e a Associação Viva que, caso qualquer parte destes Termos

de Uso ou da Política de Privacidade da Associação Viva seja considerada ilegal ou

inaplicável, no todo ou em parte, por um tribunal de jurisdição competente, tal

disposição, quanto à respectiva jurisdição, será inválida apenas na medida da referida

determinação de invalidade ou inaplicabilidade, sem afetar a validade ou a

aplicabilidade dos mesmos de qualquer outra forma em outras jurisdições, sem afetar as

demais disposições dos termos, que permanecerão estar em pleno vigor e efeito.

10. Disposições Gerais

10.1. Cessão

A Associação Viva poderá ceder ou delegar estes Termos de Uso e/ou a Política de

Privacidade da Associação Viva, no todo ou em parte, a qualquer pessoa física ou

jurídica, a qualquer momento, com ou sem o seu consentimento. Você não pode ceder

ou delegar direitos ou obrigações previstas nos Termos de Uso ou na Política de

Privacidade sem o prévio consentimento por escrito da Associação Viva, sendo que é

inválida a cessão e delegação realizada por você que não seja autorizada.

10.2. Políticas Complementares

A Associação Viva pode publicar políticas adicionais relacionadas a serviços

específicos, tais como fóruns, concursos ou programas de fidelidade. Seu direito de usar

esses serviços está sujeito a tais políticas específicas e a estes Termos de Uso.

10.3. Integralidade do Contrato

Estes Termos de Uso, as Políticas Suplementares e os documentos expressamente

incorporados por referência neste documento (inclusive a Política de Privacidade da

Associação Viva e Deixe Viver) constituem a inteira avença entre você e a Associação

Viva , e substituem todos os entendimentos prévios das partes relativos à matéria em

questão, sejam eletrônicos, orais ou escritos, ou estabelecidos pelo uso, pela prática, por

política ou por precedentes, entre você e nós com relação ao Serviço.

10.4. Ausência de Renúncia

A omissão por parte da Associação Viva em exigir ou fazer valer o estrito cumprimento

por você das disposições destes Termos de Uso ou da Política de Privacidade da

Associação Viva ou a omissão no exercício de direitos previstos em tais instrumentos

não será interpretada como renúncia ou desistência do direito da Associação Viva de

reivindicar tais disposições ou se valer delas em outras ocasiões.

A renúncia expressa pela Associação Viva de disposições, condições ou exigências

destes Termos de Uso ou da Política de Privacidade da Associação Viva não constituirá

renúncia de obrigações futuras do cumprimento de tais disposições, condições ou

exigências.

Exceto no que for disposto expressa e especificamente nestes Termos de Uso, nenhuma

declaração, afirmação, autorização, renúncia, ou outros atos ou omissões pela

Associação Viva serão consideradas modificações destes Termos de Uso e não serão

juridicamente vinculantes, a menos que documentadas fisicamente por escrito, e

assinadas a mão por você e por um diretor designado da Associação Viva.

10.5. Avisos

Podemos lhe enviar avisos através de postagens em

www.associacaovivaedeixeviver.org.br através de e-mail ou de outros meios de

comunicação por dados de contato que você nos forneça. Todos os avisos dados a você

ou exigidos de você nestes Termos de Uso ou na Política de Privacidade da Associação

Viva serão por escrito e endereçados a: Rua Fortunato, 140, São Paulo, SP, CEP 01224-

030. As notificações que você fornecer em descumprimento à presente Seção de Avisos

não terá efeitos legais.

10.6. Tutelas equitativas

Você reconhece que os direitos concedidos e as obrigações assumidas no âmbito destes

Termos de Uso para a Associação Viva são de uma natureza única e insubstituível, cuja

perda causará danos irreparáveis à Associação Viva que não podem ser substituídas

apenas por indenizações monetárias, de forma que a Associação Viva fará jus a

obrigações de fazer ou a outras tutelas equitativas (sem as obrigações de prestar caução

ou garantia ou prova de danos), em caso de violações ou violações antecipatória

causadas por você.

Você renuncia irrevogavelmente aos direitos de buscar tutelas de obrigação de fazer ou

outras tutelas em equidade, ou de proibir judicialmente ou restringir o funcionamento do

Serviço ou de jogos da Associação Viva, a exploração de qualquer tipo de publicidade

ou de outros materiais emitidos para tais fins, ou a exploração do Serviço ou de

conteúdos ou outros materiais usados ou exibidos através do Serviço e concorda em

limitar suas reivindicações a pedidos de indenização monetária, limitados pela Seção 7

(se houver).

10.7. Força Maior

A Associação Viva não será responsável por atrasos ou omissões de desempenho

resultantes de causas alheias ao controle razoável da Associação Viva inclusive, sem

limitação, omissões de desempenho previsto no presente documento ocasionadas por

circunstâncias imprevistas ou por causas que esteja além do controle da Associação

Viva, tais como guerra, terrorismo, desordens, embargos, atos de autoridades civis ou

militares, incêndio, inundações, acidentes, greves, ou escassez de meios de transporte,

de combustíveis, de energia, de mão de obra ou de materiais ou outras causas de força

maior.
                        </CardText>
                        <CardActions>
                            <RaisedButton containerElement={<Link to="/mostrahistoria" />}
                                linkButton={true}
                                label={this.state.legendas.voltar}
                                style={stylelink}
                                primary={true}
                            />
                            <Checkbox
                                label={this.state.legendas.lido}
                                onCheck={this.checaLido}
                            />
                        </CardActions>
                    </Card>
                </div>
            </MuiThemeProvider>
        )
    }
}

export default GuardaEAutoriza;


// WEBPACK FOOTER //
// ./src/componentes/guardaeautoriza/GuardaEAutoriza.js